import moment from 'moment-timezone';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import TokenRequired from '../../../layout/Platform/InvoicesIntegration/TokenRequired/TokenRequired';

// import useTimer from '../../../services/hooks/UI/useTimer';
import Context from '../../../store/context';
import Button from '../../Buttons/Button/Button';
import AskInvoicesIntegration from '../AskInvoicesIntegration/AskInvoicesIntegration';
import { ReactComponent as TwoFiles } from '../../../assets/icons/TwoFiles.svg';
import { ReactComponent as ArrowReload } from '../../../assets/icons/ArrowReload.svg';

import classes from './InvoicesIntegrationStatus.module.scss';

const InvoicesIntegrationStatus = () => {
  const { businessId, businesses } = useSelector(state => state.userData);
  const { dianConnections } = businesses[businessId];
  const firstDianConnection = dianConnections[0];

  const {
    modal: { showModal, hideModal }
  } = useContext(Context);

  const isConnectedToDIAN = dianConnections?.length > 0;
  const isDIANConnectionActive = isConnectedToDIAN && firstDianConnection?.status === 'valid';

  const lastConnectionUpdateDate = moment(firstDianConnection?.lastAccessedAt);
  const nextConnectionUpdateDate = moment(lastConnectionUpdateDate).add(1, 'days');

  // const { timer } = useTimer({ isActive: isActive || isActiveIntegration, endTime: nextDay });

  const askIntegrationBelvo = type => {
    if (type === 'update') {
      showModal(<TokenRequired hideModal={hideModal} />, false);
    } else {
      showModal(
        <AskInvoicesIntegration
          title='Activa la sincronización de cuentas de cobro con la DIAN'
description='Traeremos de manera automática tus cuentas de cobro electrónicas y la información más importante de esos proveedores. Solo debes ingresar tus credenciales de la DIAN y después cada 24 horas se te enviará un código para actualizar esta sincronización.'
        />,
        false
      );
    }
  };

  return (
    <div className={classes['status-invoices']}>
      {/* <div className={isDIANConnectionActive ? classes.connected : classes.disconnect} />
      <span className={`${classes.color} ${classes['status-disconnected']} medium-14`}>
        {!isConnectedToDIAN ? (
          <>
            <span>Sincronización desconectada</span>
            <Button Icon={TwoFiles} onClick={() => askIntegrationBelvo('active')} custom='quaternary'>
              Activar sincronización
            </Button>
          </>
        ) : isDIANConnectionActive ? (
          <span>
            {`Sincronización de cuentas de cobro activa hasta el ${nextConnectionUpdateDate.format(
              'DD/MM/YYYY'
            )} a las ${nextConnectionUpdateDate.format('hh:mm A')}.`}
          </span>
        ) : (
          <>
            <span>
              {`La última sincronización de cuentas de cobro terminó el ${nextConnectionUpdateDate.format(
                'DD/MM/YYYY'
              )} a las ${nextConnectionUpdateDate.format('hh:mm A.')}. Por favor actualízala`}
            </span>
            <Button Icon={ArrowReload} onClick={() => askIntegrationBelvo('update')} custom='quaternary'>
              Actualizar sincronización
            </Button>
             {timer !== '00:00:00' ? (
              <span className='bold-14'>
                La puedes actualizar en <span className={classes.timer}>{timer}</span>.
              </span>
            ) : (
              <Button onClick={() => askIntegrationBelvo('update')} custom='quaternary'>
                Actualizar sincronización
              </Button>
            )}
          </>
        )}
      </span> */}
    </div>
  );
};

export default InvoicesIntegrationStatus;
